module.exports = __webpack_public_path__ + "img/nove-hrady.3a854297.jpg";